// extracted by mini-css-extract-plugin
export var menuIcon = "_sh-0";
export var menuIconInline = "_sh-1";